module.exports = __webpack_public_path__ + "static/EntrancePhoto-0fc62e1160485b11f3c51a4e875e6166.jpg";